<template src= "./index.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'


export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
        <div>
            
            <vs-button style="width:70px;" :color="params.data.active ? 'success' : 'warning'" class="btnSmall" @click="btnClickedHandler()" >{{params.data.active ? '노출':'비노출'}}</vs-button> 
        </div>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    },
  },
});



export default {
    name: 'artistList',
  
    data () {
        return {
            optionData : optionData,
            
            roleType : null,
            entity: '사업자개인',

            keywordOption :[
                {
                label : '뮤직스토어명', value : 'display_name'}
            ],
            keywordType :'display_name',
            keyword : '',
            total : 0,
            page: {
                pageSize : 100,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                onRowClicked: (event)=>{
                    //this.viewDetail(event)
                },
                context: {
                    componentParent: this
                },
                frameworkComponents : {
                    btnSelect : BtnSelect
                }
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            columnDefs: [
                // active: true
                // created_at: "2021-06-29T07:11:03.559Z"
                // display_name: "Genie Music"
                // group: "korea"
                // id: 270
                // musicstore_ref: null
                // name: "제휴서비스(2)"
                // operator_id: 145
                // store_link: null
                // updated_at: "2021-06-29T07:11:03.559Z"
                {headerName: '뮤직스토어',  field: 'name',  filter: false,width: 250},
                {headerName: '뮤직스토어(Display)',  field: 'display_name',  filter: false,width: 250},
                
                {headerName: '유통그룹',      field: 'group',     filter: false,width: 200,
                    cellRenderer: (data) => {
                        let text = ''
                        if(data.value == 'korea'){
                            text = '한국'
                        }else{
                            text = '해외'
                        }
                    return text
                }},
                {headerName: '유통상태',      field: 'active',     filter: false,width: 200,
                    cellRenderer: (data) => {
                        let text = ''
                        if(data.value ){
                            text = 'Active'
                        }else{
                            text = 'Inactive'
                        }
                    return text
                }},
                {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
                {headerName: '', field: 'id', filter: false,width: 110,
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.storeVisible(data);
                        },
                       
                    },
                    cellRenderer: 'btnSelect'
                },
            ],
            tableData:[
            ],
            
            totalActive : 0,
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
        this.callList()
        })
    },
    computed: {
    
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        
        callList(){
            const option = {
                sort: 'display_name',
                sortorder: 'asc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
                //is_various_artists: false, // 필수 filter
            }
            
            let query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }   
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.loadingShow()

           
            this.$store.dispatch('GET_MUSICSTORE', {
                sort: 'display_name',
                sortorder: 'asc',
                page: 0 ,
                limit: 1,
                active : 'true'
            })
            .then(result =>{
                this.totalActive = result.filtered
                this.$store.dispatch('GET_MUSICSTORE', option)
                .then(result =>{
                    this.loadingHide()
                    this.tableData  = result.items // 권리자 목록
                    
                    this.total = result.total // 총인원수 
                    this.filtered = result.filtered // limit에 따른 수
                    //페이지 수
                    const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                    this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
                }).catch(error=>{
                    const status = error.response.status
                    this.loadingHide()
                    switch(status){
                        
                        case 401:
                        this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                        break;
                        default:
                            this.alert({msg : error.response.data.message})
                        break;
                    }
                })
            }).catch(error=>{
                
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        storeVisible(data){
            let payload = {
                id : data.id,
                params : {
                    "active": !data.active,
                }
            }
            console.log(payload)
            this.confirm({
                title : '스토어 변경 확인',
                msg : `
                    선택하신 뮤직스토어 상태를 ${!data.active ? '노출' : '비노출'}로 변경하시겠습니까?
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch('PUT_MUSICSTORE_SERVICE', payload)
                    .then(result =>{
                        this.closeModal('confirm')
                        this.loadingHide()
                        this.callList()
                    }).catch(error=>{
                        const status = error.response.status
                        this.loadingHide()
                        switch(status){
                            case 401:
                            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                            break;
                            default:
                                this.alert({msg : error.response.data.message})
                            break;
                        }
                    })
                }
            })
        },
    }
}
</script>

<style scoped>

</style>
